import React from 'react'
import AffordabilityWidget from './AffordabilityWidget'

const PayUMoneyPayment = () => {
  return (
    <AffordabilityWidget key='OADt8R' amount='6000'/>
  )
}

export default PayUMoneyPayment